// extracted by mini-css-extract-plugin
export var circle = "SpottingChickenpox-module--circle--79d6f";
export var image = "SpottingChickenpox-module--image--774b4";
export var wrapper = "SpottingChickenpox-module--wrapper--e4d00";